import React from 'react';

import NextErrorPage from 'next/error';
import {useRouter} from 'next/router';
import {FormattedMessage} from 'react-intl';
import styled from 'styled-components';

import {colors} from '@stryd/react-ui';
import {HttpStatus} from '@stryd/util-lib';

import {Layout, SEOProps, InternalLink} from 'src/components';
import Bugsnag from 'src/utils/analytics/bugsnag';
import {pathContainsLocalizationPrefix} from 'src/utils/router';

const ErrorWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

const ErrorCode = styled.span`
  font-size: 5rem;
  border-bottom: 5px solid ${colors.themes.dark.accentPrimary};
  margin-bottom: 20px;
`;

const ErrorMessage = styled.span`
  margin-bottom: 20px;
`;

const pageNotFoundSEOProps: SEOProps = {
  title: 'Page not found',
  description: 'Page not found.',
  includeInRegions: ['all'],
  slugPrefix: '',
  slug: '404',
  noIndex: true,
};

const PageNotFound: React.FC<React.PropsWithChildren<unknown>> = () => {
  const router = useRouter();

  const localizedParams = pathContainsLocalizationPrefix(router.asPath);

  Bugsnag.notify(new Error(`User on 404 page at path: ${router.asPath}`));

  return localizedParams ? (
    <Layout pageContext={localizedParams} seo={pageNotFoundSEOProps}>
      <ErrorWrapper>
        <ErrorCode>{HttpStatus.NotFound}</ErrorCode>
        <ErrorMessage>
          <FormattedMessage
            id="404.message"
            defaultMessage="Sorry, we could not find the page you are looking for."
          />
        </ErrorMessage>
        <InternalLink href={'/'}>
          <FormattedMessage id="404.returnHome" defaultMessage="Return Home" />
        </InternalLink>
      </ErrorWrapper>
    </Layout>
  ) : (
    <NextErrorPage statusCode={HttpStatus.NotFound} />
  );
};

export default PageNotFound;
